export const ReportFieldDisabledValue: React.FC<{ value?: string | null }> = ({ value }) => {
  return value || "--";
};
